/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ChangeProjectPhaseMutationVariables = Types.Exact<{
  input: Types.ChangeProjectPhaseInput;
}>;


export type ChangeProjectPhaseMutation = { changeProjectPhase: { __typename: 'ChangeProjectPhaseResult', project: { __typename: 'Project', id: string, phase: { __typename: 'OrganisationProjectPhase', id: string, name: string } } } };


export const ChangeProjectPhaseDocument = gql`
    mutation ChangeProjectPhase($input: ChangeProjectPhaseInput!) {
  changeProjectPhase(input: $input) {
    project {
      id
      phase {
        id
        name
      }
    }
  }
}
    `;
export type ChangeProjectPhaseMutationFn = Apollo.MutationFunction<ChangeProjectPhaseMutation, ChangeProjectPhaseMutationVariables>;

/**
 * __useChangeProjectPhaseMutation__
 *
 * To run a mutation, you first call `useChangeProjectPhaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeProjectPhaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeProjectPhaseMutation, { data, loading, error }] = useChangeProjectPhaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeProjectPhaseMutation(baseOptions?: Apollo.MutationHookOptions<ChangeProjectPhaseMutation, ChangeProjectPhaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeProjectPhaseMutation, ChangeProjectPhaseMutationVariables>(ChangeProjectPhaseDocument, options);
      }
export type ChangeProjectPhaseMutationHookResult = ReturnType<typeof useChangeProjectPhaseMutation>;
export type ChangeProjectPhaseMutationResult = Apollo.MutationResult<ChangeProjectPhaseMutation>;
export type ChangeProjectPhaseMutationOptions = Apollo.BaseMutationOptions<ChangeProjectPhaseMutation, ChangeProjectPhaseMutationVariables>;